/**
 * ErrorFallback — заглушка при ошибке рендера маршрута.
 *
 * Подключена как defaultErrorComponent роутера: любая ошибка рендера показывает
 * это (с текстом и кнопкой перезагрузки) ВМЕСТО пустой белой страницы.
 */
import { Button } from '@/components/ui/button'

export function ErrorFallback({
  error,
  reset,
}: {
  error?: unknown
  reset?: () => void
}) {
  const message =
    error instanceof Error ? error.message : typeof error === 'string' ? error : 'Неизвестная ошибка'

  return (
    <div className="min-h-[60vh] flex items-center justify-center p-6">
      <div className="max-w-md w-full rounded-lg border border-slate-200 bg-white p-6 space-y-3 text-center shadow-sm">
        <h1 className="text-lg font-semibold text-foreground">Что-то пошло не так</h1>
        <p className="text-sm text-muted-foreground">
          Произошла ошибка на этой странице. Данные не потеряны — можно перезагрузить.
        </p>
        <pre className="text-xs text-left bg-slate-50 border border-slate-200 rounded p-2 overflow-auto max-h-40 whitespace-pre-wrap">
          {message}
        </pre>
        <div className="flex gap-2 justify-center">
          <Button
            size="sm"
            type="button"
            onClick={() => (reset ? reset() : window.location.reload())}
          >
            Перезагрузить
          </Button>
          <Button
            size="sm"
            variant="outline"
            type="button"
            onClick={() => window.location.assign('/')}
          >
            На главную
          </Button>
        </div>
      </div>
    </div>
  )
}
